import { useQuery } from "@tanstack/react-query";
import type { client, insights } from "@duress/shared";
import { getBenchmark, getIndustries } from "./api";

export function useIndustries(
  month: string | null,
  region: client.Region,
): {
  data: insights.IndustriesResponse | undefined;
  isLoading: boolean;
  error: unknown;
  refetch: () => void;
} {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["insights", "industries", month, region] as const,
    queryFn: () => getIndustries(month, region),
  });
  return { data, isLoading, error, refetch: () => void refetch() };
}

export function useBenchmark(
  clientId: string,
  month: string | null,
): {
  data: insights.BenchmarkResponse | undefined;
  isLoading: boolean;
  error: unknown;
} {
  const { data, isLoading, error } = useQuery({
    queryKey: ["insights", "benchmark", clientId, month] as const,
    queryFn: () => getBenchmark(clientId, month),
    enabled: Boolean(clientId),
  });
  return { data, isLoading, error };
}
